import { render, staticRenderFns } from "./GP2BrowserViewportControls.vue?vue&type=template&id=89ebfe6a&scoped=true&"
import script from "./GP2BrowserViewportControls.vue?vue&type=script&lang=js&"
export * from "./GP2BrowserViewportControls.vue?vue&type=script&lang=js&"
import style0 from "./GP2BrowserViewportControls.vue?vue&type=style&index=0&id=89ebfe6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ebfe6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89ebfe6a')) {
      api.createRecord('89ebfe6a', component.options)
    } else {
      api.reload('89ebfe6a', component.options)
    }
    module.hot.accept("./GP2BrowserViewportControls.vue?vue&type=template&id=89ebfe6a&scoped=true&", function () {
      api.rerender('89ebfe6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/gp2Browser/GP2BrowserViewportControls.vue"
export default component.exports